import React, { useEffect, useState } from 'react'
import { AMMINISTRAZIONE_TRASPARENTE_URL } from '../../constants'
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  useEffect(() => {
    console.log("location", location)
  }, [location]);

  return (

    <div className={`flex w-full ${location.pathname === AMMINISTRAZIONE_TRASPARENTE_URL || location.pathname === '/privacy-policy' || location.pathname === '/whistleblowing' || location.pathname === '/cookie-policy' || location.pathname === '/rehabilitation' ? "h-[100px] sm:h-[150px] md:h-[200px] lg:h-[280px]" : ""}`}>
      <img
        loading="lazy"
        src={location.pathname !== '/' ? "/images/Header2.jpeg" : '/images/header.jpg'}
        // src={location.pathname === AMMINISTRAZIONE_TRASPARENTE_URL || location.pathname === "/privacy-policy" || location.pathname === "/cookie-policy" || location.pathname === "/whistleblowing" ? "/images/header_two.jpg" : "/images/header.png"}
        className={`w-full object-center ${location.pathname !== '/' ? 'object-cover object-top' : ''}`}
      />
      {/* Header Logo */}
      <div className="absolute top-10 left-8 xl:left-24 z-20">
        <Link to={"/"} className="cursor-pointer">
          <img
            loading="lazy"
            src="/images/logoPapaxiiiheader.png"
            className="w-1/3 lg:w-[60%] xl:w-4/6"
          />
        </Link>
      </div>
    </div>
  )
}

export default Header